
import styled from 'styled-components';

export default styled.div`
	flex: 1; /* Grow to consume remaining space */
	background-color: #ffffff;
	padding: 20px 10px 10px 10px;
`;
